
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/traffic-fines/[city]",
      function () {
        return require("private-next-pages/traffic-fines/[city]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/traffic-fines/[city]"])
      });
    }
  